<div class="upgrade-modal-backdrop">
  <div class="upgrade-modal">
    <button class="close-btn" aria-label="Close" (click)="close()">
      <i class="bi bi-x-lg"></i>
    </button>

    <h2 class="title">Upgrade to {{ planName }}</h2>
    <div class="price">₹{{ price }}</div>

    <p class="subtitle">Perfect for beginners starting their career journey</p>

    <div class="bg">
      <label class="referral-label">
        Have a referral code? <span>(Optional)</span>
      </label>

      <form [formGroup]="referralCodeForm">
        <div class="referral-input-wrapper">
          <input
            type="text"
            placeholder="Enter code"
            class="referral-input"
            formControlName="referral_code"/>

          <button
            class="btn-add m-0"
            (click)="postReferralCode()"
            type="button">
            <ng-container *ngIf="isApplying; else noApplying">
              <span class="spinner-text">
                <mat-spinner
                  [diameter]="20"
                  class="spinner-white"
                ></mat-spinner>
              </span>
            </ng-container>
            <ng-template #noApplying> Apply </ng-template>
          </button>
        </div>
      </form>

      <span class="error-text" *ngIf="isCodeValid === false">Invalid or expired referral code</span>

      <ng-container *ngFor="let referralCode of referralData">
        <div class="text-start">
          <span class="referral-success" *ngIf="isCodeValid === true">
            Referral applied successfully. You saved
            {{ referralCode.discount_percentage }}% on this plan.
          </span>
        </div>
      </ng-container>

      <div class="price-breakdown" *ngIf="isCodeValid === true">
        <div class="price-row amount">
          <span>Total payable amount</span>
          <span>₹ {{ discountedPrice }}</span>
        </div>

        <div class="price-row discount">
          <span> (Amount charged after discounts)</span>
        </div>
      </div>
    </div>

    <button
      class="btn-add w-100"
      type="button"
      (click)="payNow()"
      *hasPermission="PermissionForStudents.PAYMENTS_CREATE">
      <ng-container *ngIf="isCodeValid === true; else showPayNowButton"> Pay Now ₹{{ discountedPrice }} </ng-container>
      <ng-template #showPayNowButton> Pay Now ₹{{ price }}</ng-template>
    </button>

    <p class="note">You'll be redirected to Razorpay checkout.</p>
  </div>
</div>
